import React from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";


export default function SinglePage(props: { pdf: any }) {
  const { pdf } = props;
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const Preview: any = Worker;
  const View: any = Viewer;

  return (
    <>
      <div className='App-pdf'>
        <div className='page-container'>
          <Preview workerUrl='https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.js'>
            <div
              style={{
                height: "750px",
                maxWidth: "900px",
                marginLeft: "auto",
                marginRight: "auto"
              }} >
              <View fileUrl={pdf} plugins={[defaultLayoutPluginInstance]} />
            </div>
          </Preview>
        </div>
      </div>
    </>
  );
}
